<div
  class="max-w-0 overflow-hidden"
  [@expandColapseSecondaryDrawer]="dashboardState.secondaryDrawer()">
  <ul class="flex min-w-[260px] flex-col gap-1 px-4 pt-4">
    @for (route of parsedRoutes(); track $index) {
      @let isActivePath = activePath().includes(route.fullPath);
      <li
        routerLink="{{ route.fullPath }}"
        [attr.analytics-label]="
          'portfolio/facility/secondary-menu/item/' +
          (route.analyticsLabel ??
            route.title.toLowerCase().replaceAll(' ', '-'))
        "
        class="flex h-9 w-full cursor-pointer items-center gap-2 rounded-lg px-3"
        [class]="isActivePath ? 'selected' : 'not-selected'"
        (click)="dashboardState.setSecondaryDrawerToFalse()">
        <ng-icon
          [name]="route.icon"
          class="text-xl"
          [class]="isActivePath ? 'text-secondary-700' : ''"></ng-icon>

        <span>{{ route.title }}</span>

        @if (route.isNew) {
          <span
            class="ml-auto rounded-full bg-secondary-100 px-2 py-0.5 text-xs font-semibold uppercase text-secondary-700">
            New
          </span>
        }
      </li>
    }
  </ul>
</div>
